/**
 * Tags directive (for the list manager)
 * @param {array} tags the array of tag objects
 * @param {boolean} [sortable=true] whether the tags should be sortable/draggable
 */

angular.module("common").directive("epiTags", function (ColorHelper, $timeout, Collapser) {
  return {
    restrict: "A",
    scope: {
      entryTags: "=tags",
      sortable: "=",
    },
    templateUrl: "/directives/epi-tags.html",
    controller: function ($scope, ColorHelper) {
      var appScope = $scope.$parent.grid.appScope;

      /**
       * Returns the styling for a tag
       * @param  {object} tag
       * @return {string} the styling for specific tag
       */
      $scope.tagStyle = function (tag) {
        if (typeof tag == "undefined") return;

        var style = tag.style();
        style.width = $scope.width + "%";
        return style;
      };

      /**
       * Set the tag width on scope for all the tags
       * @return {void}
       */
      $scope.resizeTags = function () {
        $scope.width = $scope.getWidth();
      };

      /**
       * Gets the percentage width for each tag
       * @return {integer)
       */
      $scope.getWidth = function () {
        return 100 / $scope.entryTags.length;
      };

      /**
       * Removes a tag and makes a request
       * @param  {integer} index the index of the tag
       * @return {void}
       */
      $scope.removeTag = function (index) {
        $timeout(function () {
          var tag = $scope.entryTags[index];
          $scope.entryTags.splice(index, 1);
          appScope.removeTag($scope.$parent.row.entity.ID, tag.ID).then(
            function () {},
            function () {
              // $scope.entryTags.splice(index, 0, tag)
            }
          );
        });
      };

      /**
       * The options for the taglist
       * @type {Object}
       */
      $scope.tagList = {
        appendTo: "body",
        helper: function (event, element) {
          var el = $(element).clone();
          el.width($(element).width());
          return el;
        },
        placeholder: "tag tag-placeholder",
        update: function (event, ui) {
          if (!ui.item.sortable.moved) {
            ui.item.sortable.cancel();
            return;
          }

          // If the event hasn't been already canceled, and this isn't a sort event
          if (ui.item.sortable.moved || !ui.item.sortable.isCanceled()) {
            // Set this for easy access
            var sortable = ui.item.sortable;

            // Is this a private tag or a public tag?
            var chooser = sortable.moved.private ? "privateTags" : "publicTags";

            // If this tag is coming from the tag panel (editing tags)
            // Add the tag back to the list where it came from
            if (ui.sender.hasClass("edit-tags")) {
              appScope[chooser].splice(sortable.index, 0, sortable.moved);
            }

            // Make sure the tag lists (the small lists) are up-to-date
            appScope.refreshTagLists();

            // Save the tags (makes a PATCH request)
            appScope.saveTags($scope.$parent.row.entity, sortable.moved.ID);
          }
        },
        over: function (event, ui) {
          // If the item is being dragged back over, willDelete become false
          ui.item.sortable.model.willDelete = false;

          // And set the opacity back to normal
          $(".ui-sortable-helper").css("opacity", "1");
        },
        out: function (event, ui) {
          // If the item is being dragged back over, willDelete becomes true
          ui.item.sortable.model.willDelete = true;

          // And set the opacity to half
          $(".ui-sortable-helper").css("opacity", "0.5");
        },
        beforeStop: function (event, ui) {
          // This fires at the end of the cycle,
          // if this tag is being dragged off,
          if (ui.item.sortable.model.willDelete) {
            // Hide the actual item (since it takes a split second to drag it off)
            ui.item.remove();

            // And remove the tag (makes a request)
            $scope.removeTag(ui.item.sortable.index);
            $timeout(function () {
              // $scope.mouseEnter(0)
              $scope.newCollapser();
              $scope.resetWidths();
            });
          }
        },
      };
    },
    link: function (scope, element, attrs) {
      /**
       * On mouseover for a specific tag, resize everything
       * @param  {integer} index
       * @return {void}
       */
      scope.mouseEnter = function (index) {
        scope.newCollapser();
        scope.collapser.in(index, 2000, 15);
      };

      scope.newCollapser = function () {
        scope.collapser = new Collapser(element.children("ul"));
      };

      /**
       * On mouse out for the entire ul, reset everything
       * @return {void}
       */
      scope.resetWidths = function () {
        if (scope.collapser) scope.collapser.out(200);
      };

      // When anything changes, reset the widths of the tags
      scope.$watch(function () {
        scope.resizeTags();
      });
    },
  };
});
